import { SERVICE_PROVIDERS, EspAccount } from 'modules/graphql';
import {
  SendingPlatform,
  ITERABLE,
  ITERABLE_SMS,
  THIRD_PARTY_SMS_SENDING_PLATFORMS,
  SENDING_PLATFORMS,
  ServiceProvidersBySendingPlatform,
  EMAIL_SENDING_PLATFORMS,
} from '../constants';

export const isSESSendingPlatform = (sp: SendingPlatform) => sp === ITERABLE;

export const isIterableSMSSendingPlatform = (sp: SendingPlatform) => sp === ITERABLE_SMS;

export const isEmailSendingPlatform = (sp: SendingPlatform) => EMAIL_SENDING_PLATFORMS.includes(sp);

export const is3rdPartySMSSendingPlatform = (sp: SendingPlatform) =>
  THIRD_PARTY_SMS_SENDING_PLATFORMS.includes(sp);

export const getAvailablePlatforms = (espDefinitions: SERVICE_PROVIDERS[]) =>
  SENDING_PLATFORMS.filter((sendingPlatform) => {
    const serviceProviders = ServiceProvidersBySendingPlatform[sendingPlatform];
    /** If at least one ESP associated with a SendingPlatform is listed -- ie.
     * SparkPost or SparkpostEU for SparkPost -- then the tile should be shown. */
    return espDefinitions.some((esp) => serviceProviders.includes(esp));
  });

export const getConnectedPlatforms = (
  availablePlatforms: SendingPlatform[],
  espAccountsBySendingPlatform: Record<SendingPlatform, EspAccount[]>,
) => [
  ITERABLE as SendingPlatform,
  ...Object.entries(espAccountsBySendingPlatform)
    .filter(([sendingPlatform]) => availablePlatforms.includes(sendingPlatform as SendingPlatform))
    .reduce(
      (acc, [sendingPlatform, accts]) =>
        accts?.length ? [...acc, sendingPlatform as SendingPlatform] : acc,
      [] as SendingPlatform[],
    ),
];

export const getUnconnectedPlatforms = (
  availablePlatforms: SendingPlatform[],
  connectedPlatforms: SendingPlatform[],
) =>
  availablePlatforms.filter(
    (sendingPlatform: SendingPlatform) => !connectedPlatforms.includes(sendingPlatform),
  );
